// here we have to put all our audio files for preloading
interface IAudioAsset {
    durationMs?: number;
}

// commenting out not used sounds, if they are not used in the game,
// we don't need to preload them, they only increase loading time

export const AUDIO_ASSETS: { [key: string]: IAudioAsset } = {
    'BlackJack RPG_VO_Line1_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_VO_Line2_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_VO_Line3_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_VO_Line5_20.10.2023.mp3': { durationMs: 1000 },
    'BlackjackRPG_Combat Music_20.10.2023.mp3': { durationMs: 1000 },
    'BlackjackRPG_Lobby Music_20.10.2023.mp3': { durationMs: 1000 },
    'BlackjackRPG_Storytelling Music_20.10.2023.mp3': { durationMs: 1000 },
    'BlackjackRPG_Title Music No Loop_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_VO_Archer_f_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_VO_Knight_f_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_VO_Wizard_f_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_VO_Boxer_f_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_VO_Archer_m_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_VO_Knight_m_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_VO_Wizard_m_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_VO_Boxer_m_20.10.2023.mp3': { durationMs: 1000 },
};

export const LAZY_AUDIO_ASSETS: { [key: string]: IAudioAsset } = {
    'BlackJack RPG_Card Land SFX_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_Chest SFX_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_Coin SFX_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_Damage Hit SFX_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_f_Pain SFX_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_Gen Btn SFX_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_Hit1 SFX_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_Hit2 SFX_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_m_Pain SFX_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_PowerUp1 SFX_20.10.2023.mp3': { durationMs: 1000 },
    'BlackJack RPG_Sword SFX_20.10.2023.mp3': { durationMs: 1000 },
    'BlackjackRPG_Somber Music_20.10.2023.mp3': { durationMs: 1000 },
    'BlackjackRPG_Victory Fanfare_20.10.2023.mp3': { durationMs: 1000 },
};
